import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/portfolio")({
  component: PortfolioView,
});

function PortfolioView() {
  const { t } = useTranslation("common");

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">{t("portfolio.title")}</h2>
      <p className="text-muted-foreground">{t("portfolio.placeholder")}</p>
    </div>
  );
}
